module.exports = __webpack_public_path__ + "static/media/alsoReadImageRight.e2e87795.svg";